import {
  Skeleton as MuiSkeleton,
  SkeletonProps,
  Typography,
  TypographyProps,
} from "@mui/material";
import styled from "@mui/material/styles/styled";

import { Thumbnail } from "@app/analytics/components/IconVideoThumbnail";
import PlaybackOverlay, {
  PlaybackOverlayButton,
} from "@app/analytics/components/PlaybackOverlay";

import { Column, Row } from "@rui/Stack";

export const Card = styled(Column)(({ theme }) => ({
  borderRadius: "6px",
  border: `1px solid ${theme.palette.shades.neutral[100]}`,
  padding: theme.spacing(1),
  backgroundColor: "#FFF",
  maxWidth: "188px",
}));

export const Label = styled((props: TypographyProps) => (
  <Typography variant="labelMed" {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.neutral[800],
}));

export const SubLabel = styled((props: TypographyProps) => (
  <Typography variant="labelReg" {...props} />
))(({ theme }) => ({
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  color: theme.palette.shades.neutral[500],
}));

const EmptyThumbnail = styled(Column)(({ theme }) => ({
  height: "97px",
  width: "172px",
  borderRadius: "4px",
  backgroundColor: "#FAFAFA",
  border: `1px dashed ${theme.palette.shades.neutral[100]}`,
  marginBottom: theme.spacing(0.5),
}));

export const EmptyVideoMoment = () => (
  <Card spacing={0.5}>
    <EmptyThumbnail />
    <SubLabel>Nothing to see here</SubLabel>
    <SubLabel>-</SubLabel>
  </Card>
);

const Skeleton = styled((props: SkeletonProps) => (
  <MuiSkeleton variant="rectangular" {...props} />
))({
  borderRadius: "4px",
});

export const LoadingVideoMoment = () => (
  <Card spacing={0.5}>
    <Thumbnail sx={{ backgroundColor: "transparent" }}>
      <Skeleton
        height="100%"
        width={172}
        sx={{ position: "relative", display: "flex" }}
      />
      <PlaybackOverlay sx={{ backgroundColor: "transparent" }}>
        <PlaybackOverlayButton icon="play" disabled />
      </PlaybackOverlay>
    </Thumbnail>
    <Skeleton width={140} height={14} />
    <Row spacing={0.5}>
      <Skeleton width={40} height={14} />
      <Skeleton width={120} height={14} />
    </Row>
  </Card>
);
